import { XMarkIcon } from "@heroicons/react/20/solid";
import IconButton from "components/elements/IconButton";
import LazyImage from "components/elements/LazyImage";
import classes from "./classes.module.scss";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { useEffect, useState } from "react";
import { container } from "tsyringe";
import MediaService from "services/projects/MediaService";

const mediaService = container.resolve(MediaService);

type IProps = {
	media: MediaResponseResource;
	isOpen: boolean;
	onClose: () => void;
};

export default function ImageMediaModal(props: IProps) {
	const [image, setImage] = useState<string | null>(null);

	useEffect(() => {
		if (!props.media.file) return;
		mediaService.downloadFile(props.media.project.id, props.media.id).then((res) => {
			setImage(URL.createObjectURL(res));
		});
	}, [props]);

	return (
		props.isOpen && (
			<div className={classes["root"]}>
				<div className={classes["backdrop"]} onClick={props.onClose} />
				<div className={classes["content"]}>
					<LazyImage src={image} alt={"Media image"} className={classes["media"]} />
					<IconButton className={classes["close-button"]} icon={<XMarkIcon />} onClick={props.onClose} />
				</div>
			</div>
		)
	);
}
